<template>
    <MainTempComp
        ref="mainTempRef"
        :searchOption="data.searchOption"
        :handleSearch="handleSearch"
    >
        <template #header>
            <span style="padding-left: 10px"></span>
            <!-- 新增：添加按钮点击触发图片上传 -->
            <el-button
                type="primary"
                @click="handleTriggerUpload"
            >上传视频</el-button>
        </template>
        <template #main>
            <tableComp :tableData="data.tableData"></tableComp>
        </template>
    </MainTempComp>

    <!-- 图片上传组件：默认隐藏，通过点击添加按钮触发 -->
    <el-upload
        ref="uploadRef"
        class="upload-demo"
        :action="uploadApi"
        :auto-upload="false"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="beforeUpload"
        :file-list="data.uploadFileList"
    >
        <el-button type="primary">点击上传</el-button>
    </el-upload>

    <add-edit-user
        ref="AddEditUserRef"
        :currentData="data.currentData"
    ></add-edit-user>
    <addAndEdit
        v-if="data.showAddAndEdit"
        v-model:toggle="data.showAddAndEdit"
    ></addAndEdit>
</template>

<script>
import { onMounted, provide, reactive, ref, computed } from "vue";
import tableComp from "./table.vue";
import AddEditUser from "./children/add-edit-user.vue";
import addAndEdit from "./addAndEdit.vue";
import { VipVideoList, apiTimeConfigUpdate } from "@/api/requestApis";
// 引入Element Plus的Message组件（确保已安装）
import { ElMessage } from "element-plus";

export default {
    name: "userManage",
    components: {
        addAndEdit,
        tableComp,
        AddEditUser,
    },
    setup() {
        const mainTempRef = ref(null);
        const AddEditUserRef = ref(null);
        const uploadRef = ref(null);  // 上传组件ref

        // 上传API地址（改为常量，方便维护）
        const uploadApi = ref("/api/fileUpload/upload");

        // 新增：动态生成上传请求头（携带Token）
        const uploadHeaders = computed(() => {
            const token = localStorage.getItem("token") || "";
            return {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "multipart/form-data"
            };
        });

        const data = reactive({
            showAddAndEdit: false,
            tableData: [],
            currentData: {},
            searchOption: [],
            uploadFileList: []  // 存储上传文件列表
        });

        // 查询逻辑（保持不变）
        const handleSearch = async () => {
            // 加载中状态（可选，提升体验）
            if (mainTempRef.value) {
                mainTempRef.value.loading = true;
            }
            data.tableData = [];
            try {
                const res = await VipVideoList({
                    size: mainTempRef.value.pageSize,
                    current: mainTempRef.value.currentPage,
                    ...mainTempRef.value.searchParams,
                });
                console.log("表格数据：", res)
                mainTempRef.value.setTotalValue(res && res.total);
                data.tableData = res.records || [];
            } catch (err) {
                ElMessage.error("表格数据加载失败：" + err.message);
            } finally {
                // 关闭加载状态
                if (mainTempRef.value) {
                    mainTempRef.value.loading = false;
                }
            }
        };

        // 新增：上传前校验Token是否存在
        const beforeUpload = (file) => {
            const token = localStorage.getItem("token");
            if (!token) {
                ElMessage.error("登录状态失效，请重新登录！");
                return false; // 阻止上传
            }
            console.log('file',file)
            // 可选：文件类型/大小校验
            const isVideo = file.type.includes("video");
            const isImage = file.type.includes("image");
            const isAllow = isVideo || isImage;
            if (!isAllow) {
                ElMessage.error("仅支持上传图片/视频文件！");
                return false;
            }
            const isLt100M = file.size / 1024 / 1024 < 100; // 限制100MB以内
            if (!isLt100M) {
                ElMessage.error("文件大小不能超过100MB！");
                return false;
            }
            return true;
        };

        // 新增：触发文件选择 + 手动上传
        const handleTriggerUpload = () => {
            if (uploadRef.value) {
                const uploadInput = uploadRef.value.$el.querySelector('input[type="file"]');
                if (uploadInput) {
                    uploadInput.click();
                    // 监听文件选择事件，选择后自动上传
                    uploadInput.onchange = () => {
                        if (uploadInput.files.length > 0) {
                            uploadRef.value.submit(); // 手动触发上传
                        }
                    };
                }
            }
        };

        // 新增：上传成功回调【核心修改：添加刷新表格逻辑】
        const handleUploadSuccess = async (response, file, fileList) => {
            console.log("文件上传成功", response, file);
            data.uploadFileList = fileList;
            // 清空已选择的文件，避免重复上传
            if (uploadRef.value) {
                uploadRef.value.clearFiles();
            }

            // 【关键修改1：上传成功后刷新表格数据】
            ElMessage.success("文件上传成功");
            await handleSearch(); // 调用查询方法刷新表格
            // 将上传结果传递给添加编辑组件
            data.currentData.uploadFileInfo = {
                url: response.data?.url,
                fileName: file.name,
                fileSize: file.size,
                fileId: response.data?.id
            };
        };

        // 新增：上传失败回调
        const handleUploadError = (err, file, fileList) => {
            console.error("文件上传失败", err);
            ElMessage.error(`上传失败：${err.message || "网络异常，请重试"}`);
            // 清空失败的文件
            if (uploadRef.value) {
                uploadRef.value.clearFiles();
            }
        };

        const handleAddOwner = () => {
            data.currentData = { userType: 1 };
            AddEditUserRef.value.handleToggle(true);
        };

        const handleAddWasher = () => {
            data.currentData = { userType: 2 };
            AddEditUserRef.value.handleToggle(true);
        };

        const handleUpdateTable = () => {
            handleSearch();
        };

        provide("handleUpdateTable", handleUpdateTable);
        provide("handleSearch", handleSearch);

        onMounted(() => {
            handleSearch();
        });

        return {
            AddEditUserRef,
            handleAddWasher,
            handleAddOwner,
            mainTempRef,
            uploadRef,
            uploadApi,
            uploadHeaders,
            data,
            handleSearch,
            handleTriggerUpload,
            handleUploadSuccess,
            handleUploadError,
            beforeUpload
        };
    },
};
</script>

<style scoped>
/* 可选：调整上传组件样式 */
.upload-demo {
    position: absolute;
    z-index: -1;
}
</style>
